module.exports = "/fonts/Cabin-MediumItalic.ttf";